import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=1f920ce8&scoped=true&"
import script from "./contractInfo.vue?vue&type=script&lang=js&"
export * from "./contractInfo.vue?vue&type=script&lang=js&"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=1f920ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f920ce8",
  null
  
)

export default component.exports